@if (additionalCost()) {
    <div class="article">
        <div class="cost-type-indicator">
            @switch (additionalCost().type) {
                @case (AdditionalCostType.DELIVERY_COST) {
                    {{ 'Frachtkosten' | translate }}
                }
            }
        </div>
        <div class="col">
            <div class="row mb-4">
                <div class="col">
                    <span class="font-11 fw-bold">{{ additionalCost().name }}</span>
                </div>
            </div>
            <div class="row mb-2" *showOnDebug>
                <div class="col">
                    <strong>{{ 'ID' | translate }}</strong>
                    :
                    <span copyToClipboard>{{ additionalCost().id }}</span>
                </div>
            </div>
            @if (additionalCost().supplierArticleNumber) {
                <div class="row mb-2">
                    <div class="col">
                        <strong>{{ 'Artikelnummer Lieferant' | translate }}</strong>
                        :
                        <span copyToClipboard>{{ additionalCost().supplierArticleNumber }}</span>
                    </div>
                </div>
            }
            <div class="row mb-2">
                @if (accountings()) {
                    <div class="col-auto p-0">
                        <accounting-selection-v2
                            [values]="accountings()!"
                            [costCenterEditable]="!isReadonly()"
                            [projectEditable]="!isReadonly()"
                            [generalLedgerAccountEditable]="!isReadonly()"
                            [customAccountAssignmentEditable]="!isReadonly()"
                            [demandId]="demandId()"
                            [taskId]="taskId()"
                            [companyCodeId]="companyCodeId() ?? ''"
                            (initialized)="accountingsInitialized.emit()"
                            (accountingChanged)="onAccountingChange($event)"
                            (validationChanged)="validationChanged.emit($event)"
                        ></accounting-selection-v2>
                    </div>
                } @else {
                    <div class="col-auto">
                        <iim-spinner size="medium" color="secondary"></iim-spinner>
                    </div>
                }
            </div>
            <div class="row justify-content-end mx-auto mt-4 align-items-end">
                <div class="col-xxl-3 col-xl-3 col-lg-5 col-md-7 col-sm-12 mt-3">
                    <div class="row mx-auto">
                        <div class="col">
                            <div class="row justify-content-end">
                                <div class="col">
                                    <div class="row">
                                        <div class="col ps-0">
                                            {{ 'Steuersatz' | translate }}
                                        </div>
                                        <div class="col-auto pe-0">{{ additionalCost().price.taxRate }}%</div>
                                    </div>
                                </div>
                            </div>
                            <div class="row justify-content-end">
                                <div class="col">
                                    <div class="row font-12 fw-bold">
                                        <div class="col ps-0">
                                            {{ 'Preis' | translate }}
                                        </div>
                                        <div class="col-auto pe-0">
                                            <display-currency
                                                [value]="additionalCost().price.linePrice"
                                                [currencyCode]="additionalCost().price.currency"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
}
